import React from 'react'
import Head from 'next/head';
import Image from "next/image";
import styles from "../tnpsc-admissions/tnpsc-admissions.module.css";
import Banner from "../../assets/images/Tnpsc/TNPSC-RESULT-Web-Banner-2025.jpg";
import mbBanner from "../../assets/images/Tnpsc/TNPSC-RESULT-Mobile-Banner-2025.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Interest from '../../components/might-be-interest';
import Syllabus from '../tnpsc/pre-syllabus';
import Pattern from '../tnpsc/pre-pattern';
import Exam from "../tnpsc/pre-exam";
import TNPSC_form from "../../components/Forms/tnpsc-admissions-forms";
import TNPSC_course from "../tnpsc-admissions/course-detials";
import TNPSC_test from "../tnpsc-admissions/test-series";
import TNPSC_prelims from "../tnpsc-admissions/prelims";
import Link from "next/link";
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";

const BranchAddress = dynamic(()=>import("../../components/branch-addressTNPSC"));
const About_TNPSC = () => {

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Salem TNPSC Academy | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/tnpsc-salem/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/TNPSC-Gr-I-II-Prelims-Coaching-Web-banner.b884fefb.webp",
    "description": "Succeed in TNPSC exams with Salem TNPSC Academy. Expert coaching, comprehensive preparation. Enroll now for a successful TNPSC journey ahead!"
  }
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  return (
    <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Salem TNPSC Academy | Shankar IAS Academy</title>
            <meta name="title" content="Salem TNPSC Academy | Shankar IAS Academy" />
            <meta name="description" content="Succeed in TNPSC exams with Salem TNPSC Academy. Expert coaching, comprehensive preparation. Enroll now for a successful TNPSC journey ahead!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-salem/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Salem TNPSC Academy | Shankar IAS Academy" />
            <meta property="og:description" content="Succeed in TNPSC exams with Salem TNPSC Academy. Expert coaching, comprehensive preparation. Enroll now for a successful TNPSC journey ahead!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-salem/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>

      <Navbar title="tnpsc" />
      
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <div
              className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}
            >
              <Link href= '/tnpsc-admissions'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-1"
                type="button"
                role="tab"
                aria-controls="centre-1"
                aria-selected="false"
              >
                Anna Nagar
              </button>
              </Link>

              <Link href= 'tnpsc-adyar'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-2"
                type="button"
                role="tab"
                aria-controls="centre-2"
                aria-selected="false"
              >
                Adyar
              </button>
              </Link>

              <Link href= 'tnpsc-trichy'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-3"
                type="button"
                role="tab"
                aria-controls="centre-3"
                aria-selected="false"
              >
                Trichy
              </button>
              </Link>

              <Link href= 'tnpsc-salem'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4 active"
                data-bs-toggle="pill"
                data-bs-target="#centre-4"
                type="button"
                role="tab"
                aria-controls="centre-4"
                aria-selected="true"
              >
                Salem
              </button>
              </Link>

              <Link href= 'tnpsc-coimbatore'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-5"
                type="button"
                role="tab"
                aria-controls="centre-5"
                aria-selected="false"
              >
                Coimbatore
              </button>
              </Link>

              <Link href= 'tnpsc-madurai'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-6"
                type="button"
                role="tab"
                aria-controls="centre-6"
                aria-selected="false"
              >
                Madurai
              </button>
              </Link>

              <Link href= 'tnpsc-namakkal'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-7"
                type="button"
                role="tab"
                aria-controls="centre-7"
                aria-selected="false"
              >
                Namakkal
              </button>
              </Link>

              <Link href= 'tnpsc-thiruvarur'>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-8"
                type="button"
                role="tab"
                aria-controls="centre-8"
                aria-selected="false"
              >
                Thiruvarur
              </button>
              </Link>

            </div>
          </div>
        </div>
     
      <div className="container">
          <h1 className={`${styles.pagemaintitle}`}>Admission TNPSC</h1>
      </div>
  
      </div>

     
      {/* large screens */}
      <div className="container pb-2">
        <div className="row">
          <div className="col d-none d-sm-block">
            <Image src={Banner} className="img-fluid w-100" alt="Tnpsc Exam" title="Tnpsc Exam" />
          </div>
        </div>
      </div>

      {/* small screens */}
      <div className="container pb-2">
        <div className="row">
          <div className="col d-block d-sm-none">
            <Image src={mbBanner} className="img-fluid" alt="Tnpsc Exam" title="Tnpsc Exam" />
          </div>
        </div>
      </div>
      

      <div className="container pt-3">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3 align-items-baseline justify-content-lg-center`}
            >
              <Link href='#coursedetails'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4 active"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-1"
                  type="button"
                  role="tab"
                  aria-controls="centre-1"
                  aria-selected="true"
                >
                  Course Details
                </button>
              </Link>

              <Link href='#testseries'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-2"
                  type="button"
                  role="tab"
                  aria-controls="centre-2"
                  aria-selected="false"
                >
                  Test Series
                </button>
              </Link>

              <Link href='#topperlist'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-3"
                  type="button"
                  role="tab"
                  aria-controls="centre-3"
                  aria-selected="false"
                >
                 Topper List
                </button>
              </Link>

              <Link href='#examcriteria'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-4"
                  type="button"
                  role="tab"
                  aria-controls="centre-4"
                  aria-selected="false"
                >
                  Exam Criteria
                </button>
              </Link>

              <Link href='#tnpsccentres'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-5"
                  type="button"
                  role="tab"
                  aria-controls="centre-5"
                  aria-selected="false"
                >
                 Our Centres 
                </button>
              </Link>

              <Link href='/tnpsc-demo-class-video'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-6"
                  type="button"
                  role="tab"
                  aria-controls="centre-6"
                  aria-selected="false"
                >
                  TNPSC Demo Classes
                </button>
              </Link>


            </div>
          </div>
        </div>
      </div>

      {/* <TNPSC_form /> */}
      <div className="container">
<div className={`${styles.coursesimg} mb-2`}>
  <div class="col-12 col-md-6 offset-md-3 mt-4">
  <p className={`${styles.contactheader} text-center`}>Enquiry</p>
  <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
  <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
  </div>
  </div>
</div>
      <TNPSC_course />
      <TNPSC_test />
      <TNPSC_prelims />

      <div className='container'>
        <div className='row pt-3'>
          <div className='col'>
            <Pattern />
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='row pt-4'>
          <div className='col'>
            <Syllabus />
          </div>
        </div>
      </div>
      <div className='container-fluid' style={{ backgroundColor: "#F4F6F8" }}>
        <div className='row pt-4'>
          <div className='col'>
            <Exam />
          </div>
        </div>

      </div>

      <BranchAddress />
      <Interest />
      <Footer />
    </>
  )
}

export default About_TNPSC;